/**
 * Retour a l'accueil du site multi-jeux (dkg-intro).
 *
 * Quand le jeu tourne dans l'iframe plein ecran de la page d'accueil,
 * naviguer vers "/" rechargerait l'accueil *dans* l'iframe. On demande
 * plutot a la page parente de fermer l'iframe via le postMessage
 * "dkg:close" qu'ecoute l'index.html de dkg-intro. Hors iframe (onglet
 * direct, clic du milieu depuis l'accueil...), navigation classique.
 */
export function goHome(): void {
  if (isEmbeddedInIntro()) {
    window.parent.postMessage("dkg:close", window.location.origin);
    return;
  }
  window.location.href = "/";
}

/** Vrai si la page vit dans une iframe d'un parent du meme domaine (l'accueil). */
function isEmbeddedInIntro(): boolean {
  if (window.parent === window) return false;
  try {
    // Lever une exception ici = parent d'un autre domaine, donc pas notre accueil.
    return window.parent.location.origin === window.location.origin;
  } catch {
    return false;
  }
}
